import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"

const siteUsersListColumns = () => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, user) => <>{user.id}</>,
    },
    {
      text: "Name",
      dataField: "first_name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, user) => (
        <>{`${user.first_name} ${user.last_name}`}</>
      ),
    },
    {
      text: "Email",
      dataField: "email",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, user) => <>{user.email}</>,
    },
    {
      text: "Client",
      dataField: "vendor",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, user) => <>{user.vendor}</>,
    },
    {
      text: "Last Access",
      dataField: "last_access",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, user) => (
        <>{user?.last_access && getFormattedTime(user?.last_access)}</>
      ),
    },
    {
      text: "Member Since",
      dataField: "registered_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, user) => (
        <>{user?.registered_at && getFormattedTime(user?.registered_at)}</>
      ),
    },
  ]
}

export default siteUsersListColumns
